import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DateIntervalKey, ObjectDataRecord, TimeLineGridDataRecord } from '@types'

type InitialState = {
  totalsRows: ({ isLoading?: boolean } & TimeLineGridDataRecord)[]
}

const initialState: InitialState = {
  totalsRows: [],
}

const timeLineSlice = createSlice({
  name: 'timeLineGrid',
  initialState,
  reducers: {
    initializeDateIntervalTotals: (
      state: ObjectDataRecord,
      action: PayloadAction<TimeLineGridDataRecord[]>
    ) => {
      state.totalsRows = action.payload
    },
    setDateIntervalTotalIsLoading: (
      state: InitialState,
      action: PayloadAction<{
        rowIndex: number
        dateIntervalKey: keyof DateIntervalKey
        isLoading: boolean
      }>
    ) => {
      const { rowIndex, dateIntervalKey } = action.payload

      state.totalsRows[rowIndex] = {
        ...state.totalsRows[rowIndex],
        [dateIntervalKey]: [{ isLoading: true }],
      }
    },
    setDateIntervalTotalData: (
      state: ObjectDataRecord,
      action: PayloadAction<{
        rowIndex: number
        dateIntervalKey: keyof DateIntervalKey
        value: ObjectDataRecord
      }>
    ) => {
      const { rowIndex, dateIntervalKey, value } = action.payload

      state.totalsRows[rowIndex] = {
        ...state.totalsRows[rowIndex],
        [dateIntervalKey]: [{ isLoading: false, value }],
      }
    },
  },
})

export default timeLineSlice.reducer
export const {
  setDateIntervalTotalData,
  setDateIntervalTotalIsLoading,
  initializeDateIntervalTotals,
} = timeLineSlice.actions
